// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
if (typeof window !== 'undefined') {
  window.$a = window.$a || {};

  $a.parseUrl = function(url) {
    this.parser = document.createElement("a");
    this.parser.href = url;

    this.subdomain = function() {
      var parts = this.parser.host.split(".");

      if (parts.length === 3) {
        return parts[0];
      } else {
        return null;
      }
    };

    return {
      pathname: this.parser.pathname,
      protocol: this.parser.protocol,
      subdomain: this.subdomain(),
      host: this.parser.host,
      hostname: this.parser.hostname,
      port: this.parser.port,
    };
  };
}
